/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/heading-has-content */

import { useEffect, useRef, useState } from 'react';
import HintIconComponent from './icons/hintIcon';
import { LinkSmallText, Paragraph4, Title4 } from './web/texts/Texts';
import { trackTutorChatboxShowAdditionalInfo } from '@customtypes/events';
import { useMixpanel } from '@utils/tracking';
import CopyIconComponent from './icons/CopyIcon';
import CheckmarkIconComponent from './icons/checkmarkIcon';

export const lessonDescriptionHRComponent = () => <hr className="my-6"></hr>;
export const tutorDescriptionHRComponent = () => <hr className="my-4"></hr>;
export const tutorDescriptionHintOLComponent = ({ children }: any) => {
  return <ol className="markdown-ol pl-8">{children}</ol>;
};

export const tutorDescriptionCodeComponent = (props: any) => {
  return (
    <>
      <code
        {...props}
        className="rounded-md !bg-product-card-enabled-dark px-[4px] py-[1.5px] font-aeonikMono text-sm text-product-text-primary-dark"
      >
        {props.children}
      </code>
    </>
  );
};

export const lessonDescriptionPComponent = (props: any) => (
  <p {...props} className="mt-2 text-pretty"></p>
);

export const AITutorPComponent = (props: any) => (
  <p {...props} className="mt-2 text-pretty first:mt-0"></p>
);

export const BuilderIOPComponent = (props: any) => (
  <p {...props} className="!mt-2 text-pretty first:mt-0"></p>
);

export const LessonDescriptionOLComponent = ({
  children,
  hint,
  showHint,
  setShowHint,
}: any) => {
  const mixpanel = useMixpanel();

  function setShowHintAndTrack(showHint: boolean) {
    setShowHint(showHint);
    trackTutorChatboxShowAdditionalInfo(mixpanel, {
      toState: showHint ? 'collapsed' : 'expanded',
    });
  }

  return (
    <>
      <div className="my-4 flex flex-shrink-0 flex-col rounded-xl bg-product-background-secondary-dark p-3 text-product-text-primary-dark">
        <Title4>Tasks:</Title4>
        <ol
          className="markdown-ol list-decimal ps-5
        text-sm"
        >
          {children}
        </ol>
      </div>
      <button
        onClick={() => setShowHintAndTrack(!showHint)}
        className={`mt-6 flex items-center text-xs font-semibold text-product-text-secondary-light hover:text-product-button-primary-enabled-light dark:text-product-text-secondary-dark dark:hover:text-product-button-primary-enabled-dark ${
          hint ? '' : 'hidden'
        }`}
      >
        <HintIconComponent className="mr-2 h-4 w-4 flex-shrink-0"></HintIconComponent>
        {showHint ? 'Hide ' : 'Show '} additional info
      </button>
      <div
        className={`tutor-hint-container mt-4 rounded border border-product-line-primary-light bg-product-background-primary-light p-4 dark:border-product-line-primary-dark dark:bg-product-background-primary-dark ${
          showHint ? '' : 'hidden'
        }`}
      >
        {hint}
      </div>
    </>
  );
};

export const lessonDescriptionULComponent = ({ children }: any) => (
  <ul className="markdown-ul mt-4 list-disc">{children}</ul>
);

export const lessonDescriptionCodeComponent = (props: any) => {
  return (
    <>
      <code
        {...props}
        className="whitespace-pre-wrap break-all rounded-md bg-product-line-secondary-light px-[6px] py-[1.5px] font-aeonikMono text-sm  text-product-text-primary-light dark:bg-product-line-secondary-dark dark:text-product-text-primary-dark"
      >
        {props.children}
      </code>
    </>
  );
};

export const lessonDescriptionH1Component = (props: any) => (
  <h1 {...props} className="mt-4 text-2xl font-bold"></h1>
);

export const lessonDescriptionH2Component = (props: any) => (
  <h2 {...props} className="mt-4 text-xl font-bold"></h2>
);

export const lessonDescriptionH3Component = (props: any) => (
  <h3 {...props} className="mt-4 text-base font-bold"></h3>
);

export const preComponent = (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isCopied, setIsCopied] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const preRef = useRef<any>(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const stickyHeaderRef = useRef<HTMLDivElement>(null);

  function clickedToCopy() {
    const codeblockContent = preRef?.current?.textContent.split('\n');
    codeblockContent.pop();
    setIsCopied(true);
    navigator.clipboard.writeText(codeblockContent.join('\n'));
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  }

  const codeLanguage = props.className?.split('-')[1];

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const aiChatScrollView = document.getElementById('chat-scroll-view');

    if (!stickyHeaderRef.current || !aiChatScrollView) return;

    const observer = new IntersectionObserver(callback, {
      root: aiChatScrollView,
      rootMargin: '-1px 0px 0px 0px',
      threshold: [1],
    });

    observer.observe(stickyHeaderRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  function callback(entries: IntersectionObserverEntry[]) {
    if (!stickyHeaderRef.current) return;

    const entry = entries[0];
    if (entry && entry.intersectionRatio < 1) {
      stickyHeaderRef.current.style.borderTopLeftRadius = '0px';
      stickyHeaderRef.current.style.borderTopRightRadius = '0px';
    } else {
      stickyHeaderRef.current.style.borderTopLeftRadius = '';
      stickyHeaderRef.current.style.borderTopRightRadius = '';
    }
  }

  return (
    <div
      className="group relative mt-4 rounded-md border border-product-line-primary-dark bg-product-background-code-dark"
      translate="no"
    >
      <div
        className="sticky -top-3 mb-[30px] flex h-8 items-center justify-between space-x-2 rounded-t-md border-b border-product-line-primary-dark bg-product-background-code-dark px-4"
        ref={stickyHeaderRef}
      >
        <span className="font-mimopro text-[12px] leading-[16px] text-product2-content-secondary">
          {getCodeLanguageNameForMarkdownCodeblock(codeLanguage)}
        </span>
        <button onClick={() => clickedToCopy()}>
          <LinkSmallText
            className={`flex items-center space-x-1 rounded-lg px-2 py-1
          ${
            isCopied
              ? 'text-product-accent-success-dark'
              : 'text-product-text-primary-dark hover:bg-product2-background-tertiary'
          }
          `}
          >
            {isCopied ? (
              <CheckmarkIconComponent className="h-4 w-4"></CheckmarkIconComponent>
            ) : (
              <CopyIconComponent className="h-4 w-4"></CopyIconComponent>
            )}
            <span>{isCopied ? 'Copied!' : 'Copy Code'}</span>
          </LinkSmallText>
        </button>
      </div>
      <pre
        ref={preRef}
        className="custom-scrollbar pre-codeblock -mt-[30px] overflow-x-auto whitespace-pre px-4 py-2"
      >
        {props.children}
      </pre>
    </div>
  );
};

/**
 * Uses the languages defined by the markdown parser to return the language name
 */
export function getCodeLanguageNameForMarkdownCodeblock(codeLanguage: string) {
  switch (codeLanguage) {
    case 'html':
      return 'HTML';
    case 'css':
      return 'CSS';
    case 'javascript':
      return 'JavaScript';
    case 'jsx':
      return 'JSX';
    case 'python':
      return 'Python';
    case 'bash':
      return 'Bash';
    case 'cpp':
      return 'C++';
    case 'csharp':
      return 'C#';
    case 'json':
      return 'JSON';
    case 'java':
      return 'Java';
    case 'kotlin':
      return 'Kotlin';
    case 'lua':
      return 'LUA';
    case 'php':
      return 'PHP';
    case 'r':
      return 'R';
    case 'ruby':
      return 'Ruby';
    case 'sql':
      return 'SQL';
    case 'swift':
      return 'Swift';
    default:
      return '';
  }
}

export const lessonDescriptionImageComponent = ({
  src,
  title,
  alt,
  ...props
}: any) => (
  <img
    src={src}
    title={title}
    alt={alt}
    {...props}
    className="mt-4 rounded-md"
  ></img>
);

// NOTE: MARKDOWN PARSER COMPONENTS FOR LEARN (INTERACTIVE) LESSONS

export const learnLessonDescriptionHRComponent = () => (
  <hr className="my-6"></hr>
);

export const learnLessonDescriptionPComponent = (props: any) => (
  <p {...props} className=""></p>
);

export const learnLessonDescriptionH1Component = (props: any) => (
  <h1 {...props} className="mt-4 text-2xl font-bold"></h1>
);

export const learnLessonDescriptionH2Component = (props: any) => (
  <h2 {...props} className="mt-4 text-xl font-bold"></h2>
);

export const learnLessonDescriptionH3Component = (props: any) => (
  <h3 {...props} className="mt-4 text-base font-bold"></h3>
);

export const learnLessonDescriptionCodeComponent = (props: any) => {
  return (
    <>
      <code
        {...props}
        className="whitespace-pre-wrap rounded-md bg-product-line-secondary-light px-[6px] py-[2px] font-aeonikMono text-sm text-product-text-primary-light dark:bg-product-line-secondary-dark dark:text-product-text-primary-dark"
      >
        {props.children}
      </code>
    </>
  );
};

export const learnLessonDescriptionImageComponent = ({
  src,
  title,
  alt,
  ...props
}: any) => (
  <img
    src={src}
    title={title}
    alt={alt}
    {...props}
    className="mt-4 rounded-md"
  ></img>
);
